import request from '@/utils/request'


// 查询米波证照信息列表
export function listLicense(query) {
  return request({
    url: '/mibo/mibo-license/list',
    method: 'get',
    params: query
  })
}

// 查询米波证照信息分页
export function pageLicense(query) {
  return request({
    url: '/mibo/mibo-license/page',
    method: 'get',
    params: query
  })
}

// 查询米波证照信息详细
export function getLicense(data) {
  return request({
    url: '/mibo/mibo-license/detail',
    method: 'get',
    params: data
  })
}

// 新增米波证照信息
export function addLicense(data) {
  return request({
    url: '/mibo/mibo-license/add',
    method: 'post',
    data: data
  })
}

// 修改米波证照信息
export function updateLicense(data) {
  return request({
    url: '/mibo/mibo-license/edit',
    method: 'post',
    data: data
  })
}

// 删除米波证照信息
export function delLicense(data) {
  return request({
    url: '/mibo/mibo-license/delete',
    method: 'post',
    data: data
  })
}
